import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Routes from "./routes/Routes";
import Layout from "./components/Layout";
import PageLoader from "./components/PageLoader";
import "./App.scss";
import React, { useEffect, Suspense, useState } from "react";
import Auth from "./configurations/Auth";
import { Button } from "reactstrap";
import { UserProvider, UserConsumer } from "./UserContext";
import * as JWT from "jwt-decode";
import teoLogo from "./images/blue_teo_logo.png";
import tossLogo from "./images/toss_logo.png";
import ios from "./images/iosQR.png";
import android from "./images/Android.png";
import axios from "axios";
import { Authentication_Apis } from "./configurations/Authentication_Apis";
import {
	FaFacebook,
	FaFacebookF,
	FaLinkedinIn,
	FaYoutube,
	FaInstagram,
} from "react-icons/fa";
import "../src/components/style/commonStyles.scss";
import "../src/components/style/table.scss";
import IOSLogo from "./images/iosLogo.svg";
import AndroidLogo from "./images/androidLogo.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure({
	autoClose: 3000,
	draggable: false,
	position: "top-center",
});
const initialState = {
	user: {
		id: "",
		name: "",
		designation: "",
		empDesignation: "",
		role: "",
		department: "",
		supervisor: "",
		token: "",
		empImagePath: "",
		empJoinedOn: "",
		empRole: "",
		isConsultant: false,
	},
};

const auth = new Auth();
let currentDate = new Date();
const UserContextProvider = (props) => {
	const [state, dispatch] = React.useReducer(reducer, initialState.user);
	auth.handleAuthentication().then(() => {
		initialState.user.token = auth.idToken;
		let decoded = JWT(auth.idToken);
		localStorage.setItem("token", JSON.stringify(auth.idToken));
		if (currentDate.getTime() < decoded.exp * 1000) {
			initialState.user.id = decoded.id;
			initialState.user.name = decoded.name;
			initialState.user.designation = decoded.designation;
			initialState.user.empDesignation = decoded.empDesignation;
			initialState.user.role = decoded.role;
			initialState.user.department = decoded.department;
			initialState.user.supervisor = decoded.supervisor;
			initialState.user.token = auth.idToken;
			initialState.user.empImagePath = decoded.empImagePath;
			initialState.user.empJoinedOn = decoded.empJoinedOn;
			initialState.user.empRole = decoded.empRole
				? decoded.empRole
				: ["1"];
			dispatch({
				type: "loginUser",
				payload: {
					authenticated: true,
				},
			});
			const headers = {
				Authorization: `Bearer ${auth.idToken}`,
			};
			axios
				.get(`${Authentication_Apis.GetEmployeeInfo_API}`, {
					headers: headers,
				})
				.then(function (res) {
					initialState.user.isConsultant =
						res.data.empCode.charAt(0) === "C" ||
						res.data.empCode.charAt(0) === "c";
				});
		} else {
			localStorage.clear();
			window.location.reload();

			dispatch({
				type: "loginUser",
				payload: {
					authenticated: false,
				},
			});
		}
	});
	function checkLogin() {
		let token = localStorage.getItem("token");
		if (token) {
			token = JSON.parse(token);
			let accessToken = token;
			let decoded = JWT(token);
			if (currentDate.getTime() < decoded.exp * 1000) {
				initialState.user.id = decoded.id;
				initialState.user.name = decoded.name;
				initialState.user.designation = decoded.designation;
				initialState.user.empDesignation = decoded.empDesignation;
				initialState.user.role = decoded.role;
				initialState.user.department = decoded.department;
				initialState.user.supervisor = decoded.supervisor;
				initialState.user.token = accessToken;
				initialState.user.empImagePath = decoded.empImagePath;
				initialState.user.empJoinedOn = decoded.empJoinedOn;
				initialState.user.empRole = decoded.empRole
					? decoded.empRole
					: ["1"];
				dispatch({
					type: "loginUser",
					payload: {
						authenticated: true,
					},
				});
				const headers = {
					Authorization: `Bearer ${accessToken}`,
				};
				axios
					.get(`${Authentication_Apis.GetEmployeeInfo_API}`, {
						headers: headers,
					})
					.then(function (res) {
						if (res.data.length !== 0)
							localStorage.setItem("userDetails", JSON.stringify({
								empImagePath: res.data.imagePath,
								name: res.data.name,
								empDesignation: res.data.designation
							}));
							initialState.user.isConsultant =
								res.data.empCode.charAt(0) === "C" ||
								res.data.empCode.charAt(0) === "c";
					});
			} else {
				localStorage.clear();
				window.location.reload();
				dispatch({
					type: "loginUser",
					payload: {
						authenticated: false,
					},
				});
			}
		}
	}
	useEffect(() => {
		checkLogin();
	}, []);
	return (
		<UserProvider
			value={{
				...state,
				handleLogin: auth.signIn,
				checkLogin,
			}}
		>
			{props.children}
		</UserProvider>
	);
};
const reducer = (state, action) => {
	if (action.type === "loginUser") {
		return {
			...state,
			isAuthenticated: action.payload.authenticated,
		};
	}

	return state;
};
const App = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [isQr, setIsQr] = useState(false);
	const [isAndroidQr, setIsAndoidQr] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 200);
	}, []);
	const showAppleQR = () => {
		setIsQr(true);
	};
	const showAndroidQR = () => {
		setIsAndoidQr(true);
	};
	const LoginComponent = () => {
		return (
			<UserConsumer>
				{(user) => {
					return (
						<>
							{/* // <====================================Login Component Logic====================================> */}
							<div className="d-flex">
								<div className="col-lg-6 loginLeftTab">
									{!isQr && !isAndroidQr ? (
										<div className="contentDiv">
											<div>
												<img
													src={teoLogo}
													alt="awSnap"
													width="160px"
													height="100%"
												/>
											</div>
											<p className="aboutContent">
												TEO A/S is a Danish software
												company that provides quality
												solutions for both private and
												public companies. Our core
												competencies lie in the
												development of complex systems
												and mobile app solutions.
											</p>
											<div className="d-flex">
												<img
													style={{
														height: "32px",
														width: "32px",
														marginLeft: "3px",
														marginRight: "3px",
														cursor: "pointer",
													}}
													src={AndroidLogo}
													alt="android"
													onClick={showAndroidQR}
												/>
												<img
													style={{
														height: "32px",
														width: "32px",
														marginRight: "3px",
														cursor: "pointer",
													}}
													src={IOSLogo}
													alt="IOS"
													onClick={showAppleQR}
												/>
												<Link
													to="!#"
													target="_blank"
													className="px-1"
													rel="noopener noreferrer external"
													onClick={(event) => {
														event.preventDefault();
														window.open(
															"https://www.facebook.com/TEO.International/"
														);
													}}
												>
													<FaFacebook className="facebookLink" />
												</Link>
												<Link
													to="!#"
													className="px-1"
													target="_blank"
													rel="noopener noreferrer external"
													onClick={(event) => {
														event.preventDefault();
														window.open(
															"https://www.facebook.com/groups/30416205980/"
														);
													}}
												>
													<FaFacebookF className="fbGroup" />
												</Link>
												<Link
													to="!#"
													className="px-1"
													target="_blank"
													rel="noopener noreferrer external"
													onClick={(event) => {
														event.preventDefault();
														window.open(
															"https://www.youtube.com/channel/UC8Ql6VgvOi52OnH-bK7Og4g"
														);
													}}
												>
													<FaYoutube className="youtubeIcon" />
												</Link>
												<Link
													to="!#"
													className="px-1"
													target="_blank"
													rel="noopener noreferrer external"
													onClick={(event) => {
														event.preventDefault();
														window.open(
															"https://www.linkedin.com/company/teo-international/mycompany/"
														);
													}}
												>
													<FaLinkedinIn className="linkedIn" />
												</Link>

												<Link
													to="!#"
													className="px-1"
													target="_blank"
													rel="noopener noreferrer external"
													onClick={(event) => {
														event.preventDefault();
														window.open(
															"https://www.instagram.com/teo_intl/"
														);
													}}
												>
													<FaInstagram className="instagramIcon" />
												</Link>
											</div>
											<div className="passion">
												Passion For Software Development
											</div>
										</div>
									) : isQr ? (
										<div className="QRContent">
											<div className="qrHeader">
												<span className="qrTitle">
													{isQr
														? "Scan to download our iOS App"
														: "Scan to download our android App"}
												</span>
												<div>
													<span
														className="closeIcon"
														onClick={() =>
															setIsQr(false)
														}
													>
														x
													</span>
												</div>
											</div>
											<div className="qrBody">
												<div className="note">
													Note :
												</div>
												<p>
													Please use Chrome browser
													(not safari) to access TOSS
													app URL You have to Trust
													the profile available under{" "}
													<b>
														Settings{" "}
														<span>&#62;</span>
														General{" "}
														<span>&#62;</span>{" "}
														Profiles & Device
														Management and then
														Trust the TOSS
														Enterprise App.
													</b>
												</p>
												<div className="QR">
													<img
														src={ios}
														alt="awSnap"
													/>
												</div>
											</div>
										</div>
									) : isAndroidQr ? (
										<div className="QRContent">
											<div className="qrHeader">
												<span className="qrTitle">
													{
														"Scan to download our android App"
													}
												</span>
												<div>
													<span
														className="closeIcon"
														onClick={() =>
															setIsAndoidQr(false)
														}
													>
														x
													</span>
												</div>
											</div>
											<div className="qrBody">
												<div className="QR">
													<img
														src={android}
														alt="awSnap"
													/>
												</div>
											</div>
										</div>
									) : null}
								</div>
								<div className="col-lg-6 loginRightTab">
									<div className="contentDiv">
										<div className="d-flex justify-content-center">
											<img
												src={tossLogo}
												alt="awSnap"
												width="80%"
												height="100%"
											/>
										</div>
										<div className="row">
											<Button
												type="button"
												className="loginRightTabBtn col-md-12"
												onClick={user.handleLogin}
											>
												LOGIN
											</Button>
										</div>
									</div>
								</div>
							</div>
						</>
					);
				}}
			</UserConsumer>
		);
	};
	return (
		<UserContextProvider value={initialState.user}>
			<UserConsumer>
				{(user) => (
					<>
						{
							<Suspense>
								<Router>
									{isLoading ? (
										<PageLoader />
									) : (
										<>
											{user.isAuthenticated ? (
												<Layout>
													<Routes
														userDetails={user}
													/>
												</Layout>
											) : (
												<>
													<Route
														path="/"
														component={
															LoginComponent
														}
													/>
												</>
											)}
										</>
									)}
								</Router>
							</Suspense>
						}
					</>
				)}
			</UserConsumer>
		</UserContextProvider>
	);
};
export default App;
